import styled from 'styled-components';

export const Canvas = styled.canvas`
  filter: blur(10px);
  // blurring the canvas wil create "fuzzy" edges that bleed outside of its container.
  // this overflow can be hidden with { overflow: hidden } on the container, but the
  // blurry edges of the canvas create a halo where the overflow gets clipped. scaling
  // the canvas slightly helps to reduce the halo effect.
  transform: scale(1.1);
`;
